import { render, staticRenderFns } from "./Colors.vue?vue&type=template&id=2999fea0&"
import script from "./Colors.vue?vue&type=script&lang=js&"
export * from "./Colors.vue?vue&type=script&lang=js&"
import style0 from "./Colors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/tine20/Tinebase/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2999fea0')) {
      api.createRecord('2999fea0', component.options)
    } else {
      api.reload('2999fea0', component.options)
    }
    module.hot.accept("./Colors.vue?vue&type=template&id=2999fea0&", function () {
      api.rerender('2999fea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@caohenghu/vue-colorpicker/src/color/Colors.vue"
export default component.exports